import * as angular from 'angular';

import { CreditGapsTransferTableComponent } from './credit-gaps-transfer-table.component';

export const CreditGapTransferTableModule = angular
  .module('creditGapTransferTableModule', [])
  .component('creditGapsTransferTable', CreditGapsTransferTableComponent).name;
